export default __webpack_public_path__ + "static/media/file_upload_icon.b3cbafe0.svg";